module.exports = __webpack_public_path__ + "img/player-name-bg-v2.90526aa8.png";